/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2017, Zumper
 * @description   location utilities
 */

import type { MNeighborhood } from '@zcode/state-type'
import getClosestEntity from './getClosestEntity'
import type { MaybeCoords } from './getDistanceFromCenter'
import getMatchingEntity from './getMatchingEntity'
import withinBox from './withinBox'

const getBestHood = ({
  center,
  hood,
  isAutocompleteHood,
  nearbyHoods,
  url,
  useGeos,
}: {
  center: MaybeCoords
  hood?: MNeighborhood
  isAutocompleteHood?: boolean
  nearbyHoods?: readonly MNeighborhood[]
  url?: string
  useGeos: boolean
}) => {
  let hoods = []
  // We always want to return the hood if it's from an autocomplete result selection
  if (hood && isAutocompleteHood) {
    return hood
  }
  if (hood) {
    hoods.push(hood)
  }
  if (nearbyHoods?.length) {
    hoods = hoods.concat(nearbyHoods)
  }
  if (hoods.length) {
    hoods = hoods.filter((h) => withinBox(center, h.box))
  }
  if (hoods.length > 0) {
    return useGeos ? getClosestEntity(center, hoods) : getMatchingEntity(hoods, url)
  }
  return undefined
}

export default getBestHood
